/* Trademark Holders Pricing - Brands */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeTrademarkHoldersPricingBrands( value ) {
    
    /* Setup */
    var total  = 0;
    var totalA = 0;
    var totalB = 0;
    var totalC = 0;
    var totalD = 0;
    var selected = '.band-a';
    var table = jQuery( '#trademark-holders-pricing-brands-table' );
    
    /* Prices */
    var priceA = table.find( '.band-a input[type=hidden]' ).val();
    var priceB = table.find( '.band-b input[type=hidden]' ).val();
    var priceC = table.find( '.band-c input[type=hidden]' ).val();
    var priceD = table.find( '.band-d input[type=hidden]' ).val();
    
    /* Update Text */
    jQuery( '.trademark-holders-pricing-total > div:first-child > span.brands' ).html( value + ( value == 1 ? ' brand' : ' brands' ) );
    
    /* Clear Classes */
    table.find( '.selected' ).removeClass( 'selected' );
    
    /* Selected Class */
    if ( value <= 5 ) {
        selected = '.band-a';
    } else if ( value >= 6 && value <= 10 ) {
        selected = '.band-b';
    } else if ( value >= 11 && value <= 20 ) {
        selected = '.band-c';
    } else if ( value >= 21 ) {
        selected = '.band-d';
    }
    
    /* Band A */
    if ( value >= 1 ) {
        totalA = Math.max( 0 , Math.min( Math.max( value , 1 ), 5 ) * priceA );
        total += totalA;
    }
    table.find( '.band-a > td + td' ).html( '£' + totalA );
    
    /* Band B */
    if ( value >= 6 ) {
        totalB = Math.max( 0 , Math.min( Math.max( value - 5 , 1 ), 5 ) * priceB );
        total += totalB;
    }
    table.find( '.band-b > td + td' ).html( '£' + totalB );
    
    /* Band C */
    if ( value >= 11 ) {
        totalC = Math.max( 0 , Math.min( Math.max( value - 10 , 1 ), 10 ) * priceC );
        total += totalC;
    }
    table.find( '.band-c > td + td' ).html( '£' + totalC );
    
    /* Band D */
    if ( value >= 21 ) {
        totalD = Math.max( 0 , Math.min( Math.max( value - 20 , 1 ), 1 ) * priceD );
        total += totalD;
    }
    table.find( '.band-d > td + td' ).html( '£' + totalD );
    
    /* Add Class */
    table.find( selected ).addClass( 'selected' );
    
    /* Update Total */
    table.find( '.total td:first-child + td' ).html( '£' + total );
    
    /* Return Total */
    return total;

}

/* Trademark Holders Pricing - Countries */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeTrademarkHoldersPricingCountries( value , brands ) {
    
    /* Setup */
    var total  = 0;
    var totalA = 0;
    var totalB = 0;
    var totalC = 0;
    var totalD = 0;
    var selected = '.band-free';
    var table = jQuery( '#trademark-holders-pricing-countries-table' );
    
    /* Prices */
    var priceA = table.find( '.band-a input[type=hidden]' ).val();
    var priceB = table.find( '.band-b input[type=hidden]' ).val();
    var priceC = table.find( '.band-c input[type=hidden]' ).val();
    var priceD = table.find( '.band-d input[type=hidden]' ).val();
    
    /* Update Text */
    jQuery( '.trademark-holders-pricing-total > div:first-child > span.countries' ).html( value + ( value == 1 ? ' country' : ' countries' ) );
    
    /* Clear Classes */
    table.find( '.selected' ).removeClass( 'selected' );
    
    /* Selected Class */
    if ( value <= 5 ) {
        selected = '.band-free';
    } else if ( value >= 6 && value <= 10 ) {
        selected = '.band-a';
    } else if ( value >= 11 && value <= 15 ) {
        selected = '.band-b';
    } else if ( value >= 16 && value <= 20 ) {
        selected = '.band-c';
    } else if ( value >= 21 ) {
        selected = '.band-d';
    }
    
    /* Band A */
    if ( value >= 6 ) {
        totalA = Math.max( 0 , Math.min( Math.max( value - 5 , 1 ), 5 ) * priceA ) * brands;
        total += totalA;
    }
    table.find( '.band-a > td + td' ).html( '£' + totalA );
    
    /* Band B */
    if ( value >= 11 ) {
        totalB = Math.max( 0 , Math.min( Math.max( value - 10 , 1 ), 5 ) * priceB ) * brands;
        total += totalB;
    }
    table.find( '.band-b > td + td' ).html( '£' + totalB );
    
    /* Band C */
    if ( value >= 16 ) {
        totalC = Math.max( 0 , Math.min( Math.max( value - 15 , 1 ), 5 ) * priceC ) * brands;
        total += totalC;
    }
    table.find( '.band-c > td + td' ).html( '£' + totalC );
    
    /* Band D */
    if ( value >= 21 ) {
        totalD = Math.max( 0 , Math.min( Math.max( value - 20 , 1 ), 1 ) * priceD ) * brands;
        total += totalD;
    }
    table.find( '.band-d > td + td' ).html( '£' + totalD );

    /* Add Class */
    table.find( selected ).addClass( 'selected' );
   
    /* Update Total */
    table.find( '.total td:first-child + td' ).html( '£' + total );
    
    /* Return Total */
    return total;

}

/* Trademark Holders Pricing - Update */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeTrademarkHoldersPricingUpdate() {
    
    /* Setup */
    var brands = jQuery( '#trademark-holders-pricing-brands-range-slider' ).find( 'input[type=hidden]' );
    var countries = jQuery( '#trademark-holders-pricing-countries-range-slider' ).find( 'input[type=hidden]' );
    
    /* Check Elements Exist */
    if ( brands.length && countries.length ) {    
    
        /* Range Slider Pricing - Brands */
        var valueBrands = brands.val();
        var totalBrands = ipcrimeTrademarkHoldersPricingBrands( valueBrands );
    
        /* Range Slider Pricing - Countries */
        var valueCountries = countries.val();
        var totalCountries = ipcrimeTrademarkHoldersPricingCountries( valueCountries , valueBrands );
        
        /* Update Total */
        jQuery( '.trademark-holders-pricing-total > div:first-child + div' ).html( '£' + ( totalBrands + totalCountries ) );

    }

}

/* Trademark Holders Pricing - Init */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeTrademarkHoldersPricingInit() {
    
    /* Range Slider Pricing - Brands */
    ipcrimeFormsRangeSlider( jQuery( '#trademark-holders-pricing-brands-range-slider' ) , 1 , 1 , 1 , 21 , 'brand' , 'brands' , ipcrimeTrademarkHoldersPricingUpdate );
    
    /* Range Slider Pricing - Countries */
    ipcrimeFormsRangeSlider( jQuery( '#trademark-holders-pricing-countries-range-slider' ) , 1 , 1 , 1 , 21 , 'country' , 'countries' , ipcrimeTrademarkHoldersPricingUpdate );
    
    /* Update */
    ipcrimeTrademarkHoldersPricingUpdate();

}